import {
  AuthGuard,
  LOGIN_SUCCESS_REDIRECT,
  ShellComponent,
} from '@adminprodigydesign/axis';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { HomeComponent } from './core/pages/home/home.component';
import { LoginComponent } from './features/login/login.component';
import { CheckoutPageComponent } from './core/pages/checkout-page/checkout-page.component';
import { OrderSummaryPageComponent } from './core/pages/order-summary-page/order-summary-page.component';
import { MyAccountComponent } from './core/pages/my-account/my-account.component';
import { ActivateAccountComponent } from './shared/components/activate-account/activate-account.component';
import { PaymentComponent } from './core/pages/payment/payment.component';
import { ThankYouPageComponent } from './core/pages/thank-you-page/thank-you-page.component';
import { TenantUnavailableComponent } from './core/pages/tenant-unavailable/tenant-unavailable.component';
import { CookiePolicyComponent } from './core/pages/cookie-policy/cookie-policy.component';
import { TermsOfServiceComponent } from './core/pages/terms-of-service/terms-of-service.component';
import { PasswordResetComponent } from './features/password-reset/password-reset.component';
import { RegisterSuccessComponent } from './features/register-success/register-success.component';
import { MenuComponent } from './core/pages/menu/menu.component';

const routes: Routes = [
  { path: 'unavailable', component: TenantUnavailableComponent },
  {
    path: '',
    component: ShellComponent,
    children: [
      // { path: 'home', component: HomeComponent },
      { path: 'login', component: LoginComponent },
      {
        path: 'register',
        component: LoginComponent,
        data: { mode: 'register' },
      },
      {
        path: 'forgot-password',
        component: LoginComponent,
        data: { mode: 'forgot' },
      },
      { path: 'password-reset', component: PasswordResetComponent },
      { path: 'register-success', component: RegisterSuccessComponent },
      {
        path: 'account',
        component: MyAccountComponent,
        canActivate: [AuthGuard],
      },
      { path: 'menu', component: MenuComponent },
      {
        path: 'checkout',
        component: CheckoutPageComponent,
        providers: [{ provide: LOGIN_SUCCESS_REDIRECT, useValue: '/checkout' }],
      },
      { path: 'payment', component: PaymentComponent },
      { path: 'order-confirmed', component: ThankYouPageComponent },
      {
        path: 'order-summary',
        component: OrderSummaryPageComponent,
      },
      { path: 'authentication', component: ActivateAccountComponent },
      { path: 'cookie-policy', component: CookiePolicyComponent },
      { path: 'terms-of-service', component: TermsOfServiceComponent },
      { path: '', redirectTo: 'menu', pathMatch: 'full' },
      { path: '**', redirectTo: 'menu' },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
